import { setState } from './helpers'

const catalogMutations = {
  SET_CATEGORIES: setState('categories'),
  SET_CATEGORY: setState('category'),
  SET_CATEGORIES_SELECT: setState('categoriesSelect'),
  SET_CATEGORIES_MODEL: setState('categoriesModel'),

  SET_CATEGORY_UPDATE(state, payload) {
    const category = state.category_update.find((v) => v.locale === payload.locale)

    if (category) {
      state.category_update = state.category_update.map((x) =>
        x.locale === payload.locale ? { ...x, name: payload.name } : x
      )
    } else {
      state.category_update.push({
        locale: payload.locale,
        name: payload.name,
        active: payload.active
      })
    }
  },

  SET_PRODUCTS: setState('products'),
  SET_PRODUCT: setState('product'),
  SET_PRODUCTS_SELECT: setState('productsSelect'),
  SET_PRODUCT_STATUSES_SELECT: setState('productStatusesSelect'),

  SET_PRODUCT_UPDATE(state, payload) {
    const product = state.product_update.find((v) => v.locale === payload.locale)

    if (product) {
      state.product_update = state.product_update.map((x) =>
        x.locale === payload.locale ? { ...x, name: payload.name, description: payload.description } : x
      )
    } else {
      state.product_update.push({
        locale: payload.locale,
        name: payload.name,
        description: payload.description
      })
    }
  },

  SET_IMPORTED_PRODUCTS: setState('importedProducts'),
  SET_IMPORTED_PRODUCTS_TOTAL: setState('importedProductsTotal'),

  SET_WAREHOUSES: setState('warehouses'),
  SET_WAREHOUSES_COUNT: setState('warehouseCount'),

  SET_VENDOR_LIST: setState('vendorList'),
  REMOVE_VENDOR_LIST_ITEM(state, vendorId) {
    state.vendorList = Array.isArray(state.vendorList)
      ? state.vendorList.filter(
        (vendor) =>
          String(vendor.id) !== String(vendorId) &&
          String(vendor.plainId) !== String(vendorId)
      )
      : []
  },
  SET_VENDOR: setState('vendor'),
  SET_SUPPLIERS_LIST: setState('suppliersList'),
  REMOVE_SUPPLIER_LIST_ITEM(state, supplierId) {
    state.suppliersList = Array.isArray(state.suppliersList)
      ? state.suppliersList.filter(
        (supplier) =>
          String(supplier.id) !== String(supplierId) &&
          String(supplier.plainId) !== String(supplierId)
      )
      : []
  },
  SET_SUPPLIER: setState('supplier'),

  SET_PRICES: setState('prices'),
  SET_PRICE: setState('price'),
  SET_PRICE_CATEGORIES: setState('priceCategories'),
  SET_PRICE_LIST: setState('priceList'),
  SET_SINGLE_PRICE_LIST: setState('singlePriceList'),

  SET_BROCHURE_CATEGORIES: setState('brochureCategories'),
  SET_BROCHURES: setState('brochures'),
  SET_BROCHURE: setState('brochure'),
  SET_BROCHURE_FILES: setState('brochureFiles'),
  REMOVE_BROCHURE_FILE(state, fileId) {
    if (Array.isArray(state.brochureFiles)) {
      const hadFile = state.brochureFiles.some((file) => String(file.id) === String(fileId))
      state.brochureFiles = state.brochureFiles.filter((file) => String(file.id) !== String(fileId))

      if (hadFile && typeof state.totalBrochureFiles === 'number' && state.totalBrochureFiles > 0) {
        state.totalBrochureFiles -= 1
      }
    } else {
      state.brochureFiles = []
    }
  },
  SET_TOTAL_BROCHURE_FILES: setState('totalBrochureFiles')
}

export { catalogMutations }
